const monitoring = (state = [], action) => {
  switch (action.type) {
    case "ADD_MONITORING":
      return {
        userout: action.userout,
        id: action.id,
        agent: action.agent,
        line: action.line,
        ramal: action.ramal,
      };
    case "EDIT_MONITORING_M":
      if (state) {
        return { ...state, line: action.line };
      }
    case "EDIT_MONITORING_D":
      if (state) {
        return { ...state, cdrid: action.cdrid };
      }
    case "MONITORING_DEL":
      return [];
    default:
      return state;
  }
};

export default monitoring;
